import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { UsersService } from './users.service';

@Injectable({
	providedIn: 'root'
})
export class SessionService {
	constructor(private localStorage: LocalStorageService) {}

	/**
	 * Cierra la sesión y recarga la aplicación.
	 * La recarga es necesaria: sin ella los componentes que viven fuera del router-outlet
	 * (header) conservan en memoria el estado del usuario anterior, y las respuestas del
	 * backend que quedaron en vuelo escriben ese estado sobre el usuario nuevo.
	 */
	clearSessionHard(reason: 'manual' | 'session_expired' | 'refresh_failed' = 'session_expired'): void {
		if (sessionStorage.getItem('HARD_LOGOUT')) return;

		sessionStorage.setItem('HARD_LOGOUT', '1');
		sessionStorage.setItem('LOGOUT_REASON', reason);

		this.localStorage.clear();
		UsersService.loggedOut.emit(true);
		location.href = '/conta/login';
	}
}
